'use client';

import { TranslationSnapshotProvider } from '@eliadmin/core/src/i18n/translation-context';
import type { PropsWithChildren } from 'react';
import { GENERATED_TRANSLATIONS } from '../dictionaries/dictionary-dc5cefa0f86a717c300d525e2c079b7a481d7bd918b07c8d83399164269eaa03';

export default function GeneratedLocaleTranslationBoundary({ children }: PropsWithChildren) {
  return (
    <TranslationSnapshotProvider translations={GENERATED_TRANSLATIONS}>
      {children}
    </TranslationSnapshotProvider>
  );
}
